export default __webpack_public_path__ + "static/media/location_icon.b5e9ea5c.svg";